<template>

    <div  class="h-full mx-auto py-5 flex items-center justify-center z-50">
        <div class="relative mr-2  w-96 z-index-1">
        <!-- <div
            v-if="!isAdmin" class="absolute inset-0 bg-gradient-to-r from-teal-700 to-teal-500 shadow-lg  transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl z-index-0">
        </div> -->
        <div 
              draggable="true"
            class="bg-white relative p-8 rounded shadow-lg mx-auto w-80 md:w-96 z-index-1 border border-slate-200"    
        >
            
            <h1 class="text-lg font-semibold mb-4">{{ isAdmin ? $t('Müşteri Bilgi Formu') : $t('Bilgi İsteği Formu')}}</h1>
         
              <div v-if="isAdmin && form.mobile && form.mobile.length>9">
                <a :href="`/admin/user/${normalizePhoneNumber(form.mobile)}?mobile=${normalizePhoneNumber(form.mobile)}`" target="blank" class="px-2 py-1 mb-2 text-sm text-white bg-sky-400 rounded-lg">Müşteri detayına git</a>
              </div>
                <div class="mb-4 required-field" :class="isAdmin ? 'text-xs':''"> 
                    <label for="name" class="block text-gray-600 ">
                      {{$t('Full Name')}}
                    </label>
                    <input type="text" id="name" name="name" v-model="form.name" class="w-full border text-base border-gray-300 rounded py-2 px-3">
                </div>
                <div class="mb-4" v-if="isAdmin" :class="isAdmin ? 'text-xs':''"> 
                    <label for="email" class="block text-gray-600">
                        {{$t('Subject')}} </label>
                    <input type="text" id="subject" name="subject" v-model="form.subject" class="w-full text-base border border-gray-300 rounded py-2 px-3">
                </div>
                <div class="mb-4 required-field" :class="isAdmin ? 'text-xs':''"> 
                    <label for="email" class="block text-gray-600 ">
                        {{$t('Mobile')}} </label>
                         <ClientOnly>
                            <VueTelInputLazy v-model="form.mobile" mode="international" class="text-base" :inputOptions="{placeholder: $t('Telefon numarası')}"></VueTelInputLazy>
                        </ClientOnly>
                    <!-- <input type="phone" id="phone" name="phone" v-model="form.mobile" class="w-full border border-gray-300 rounded py-2 px-3"> -->
                </div> 
                <div class="mb-4" v-if="isAdmin" :class="isAdmin ? 'text-xs':''"> 
                    <label for="email" class="block text-gray-600">
                        {{$t('Email')}} </label>
                    <input type="email" id="email" name="email" v-model="form.email" class="w-full text-base border border-gray-300 rounded py-2 px-3">
                </div>
                <div class="mb-4" :class="isAdmin ? 'text-xs':''">
                    <label for="message" class="block text-gray-600">{{ isAdmin ? $t('Mesajınız') : $t('Notunuz')}}</label>
                    <textarea id="message" name="message" :class="isAdmin ? 'h-16':'h-32'"  v-model="form.message" class="w-full text-base border border-gray-300 rounded py-2 px-3 "></textarea>
                </div>

                <GlobalKVKKForm ref="globalKvkk" @confirm="event=>form.kvkk=event"></GlobalKVKKForm>
                
                <div class="w-full flex mt-2 justify-between space-x-2">
                    <button type="button" @click="formSubmit()" id="callYouFormButton" class="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600">
                        {{ form.id ? $t('Güncelle')  : $t('Gönder') }}
                    </button>
                    <button type="button"  @click="closeForm()" class="bg-slate-100 text-slate-600 py-2 px-4 rounded hover:bg-slate-200 border border-slate-200">
                        {{ $t('Cancel') }}
                    </button>
                </div>
         
            </div>
        </div>
        </div>


</template>

<script setup>
import { computed, provide} from 'vue';
import axios from "axios" 
import VueTelInputLazy from '@/components/advanced/VueTelInput.client.vue' 

// import 'vue-tel-input/vue-tel-input.css'

const user = useUser();
const contactForm = useContactForm();
const { createRecaptcha, normalizePhoneNumber } = useCommon();
const config = useRuntimeConfig();
const { getAttributionPayload, trackEvent } = useTracking()

const alert = useAlert();
const form = ref({})
const resetForm = ()=>{
  form.value = {
    name: '',
    mobile:'',
    subject:'',
    email: '',
    message:'',
    kvkk: false,
    id: null
  }
}
resetForm();

const openNoteForm = (id,data)=>{
  form.value.name = data.not_ad;
  form.value.mobile = data.not_cep;
  form.value.email =  data.not_mail;
  form.value.subject = data.not_konu;
  form.value.message = data.message;
  form.value.kvkk = data.kvkk;
  form.value.id =  id || null;
  form.value.detailId =  data.notes?.[0]?.not_d_Id;
  contactForm.value.show = true;
}

const closeForm = ()=>{
  contactForm.value.show=false;
  resetForm()
}
const checkFilled = ()=>{
  if(form.value.name && form.value.name.length > 3 && form.value.mobile && form.value.kvkk){
    return true;
  }else{
    return false;
  }
}
const formSubmit = async (data) => {


if(checkFilled()){  
await createRecaptcha().then(token=>{ 
  let path = window.location.href;
  let message = '';
  
  if(!user.value || user.value.U_Admin !== 'on'){
      message = `<strong>Mesajınız alınmıştır <br />`
      message += `<strong>Ad</strong> : ${form.value.name} <br />`;
      message += `<strong>Mobil</strong> : ${form.value.mobile} <br />`;
      message += `<strong>Email</strong> : ${form.value.email} <br />`;
      message += `<p>Mesajınız</p>`;
      message += `<strong>Not </strong>: ${form.value.message} <br />`;
  }else{
    message = form.value.message
  }
 
  
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.public.apiBase}`+"/graphql/direct",
      method: "post",
      data: {
        query: `mutation AddContactNote(
          $id: String, $name: String, $mobile: String, $email: String,
          $message: String, $subject: String, $kvkk: String, $path: String,
          $token: String, $attribution: String
        ) {
          addNote(
            id: $id, name: $name, surname: "", phone: "", mobile: $mobile,
            alertType: "", status: "Not_Active", email: $email, message: $message,
            cat: "FRM_General", subject: $subject, kvkk: $kvkk, path: $path,
            page: $path, token: $token, attribution: $attribution
          ) { not_Id }
        }`,
        variables: {
          id: form.value.id || '',
          name: form.value.name,
          mobile: form.value.mobile,
          email: form.value.email || '',
          message,
          subject: form.value.subject || 'Sizi Arayalım',
          kvkk: String(form.value.kvkk),
          path,
          token: token || '',
          attribution: JSON.stringify(getAttributionPayload() || {})
        }
      }
    })
      .then(response => { 
        if (response.status === 200) { 
          if (!isAdmin.value) {
            trackEvent('generate_lead', {
              lead_type: 'contact_form',
              lead_id: String(response?.data?.data?.addNote?.not_Id || ''),
              page_path: window.location.pathname
            })
          }
        
          contactForm.value.show = false;
          contactForm.value.id = null;
          contactForm.value.data = {};
          contactForm.value.minimize = false;
          alert.value = {
            show: true,
            title: 'Başarıyla Kaydettiniz',
            text: 'Tebrikler mesajınız başarıyla alındı.',
            type: 'success'
          }
          resolve(response);
        }
      })
      .catch(err => {
        console.log("Error:" + err);
        reject(err);
        commit("setForm", { v: sended, callback: resolve })
      });
  });
});
}
}

const  isAdmin = computed(()=>{
  return !user.value || user.value.U_Admin !== 'on' ? false : true
})
 
defineExpose({
    openNoteForm
})

</script>
